export const HOME_ARTICLES_LIMIT = 3
export const ARTICLE_DESCRIPTION_MAX_LENGTH = 160

export interface ArticleLikeForSeo {
  article_title: string
  article_content?: Array<Record<string, unknown>>
}

export function getArticleDescription(article: ArticleLikeForSeo): string {
  const first = article.article_content?.[0]
  if (!first) return article.article_title
  const text = first.text ?? first.content
  return typeof text === 'string' && text ? text.slice(0, ARTICLE_DESCRIPTION_MAX_LENGTH) : article.article_title
}

export function toISODate(value: Date | string | undefined): string {
  if (!value) return ''
  const date = typeof value === 'string' ? new Date(value) : value
  return date.toISOString().split('T')[0] ?? ''
}

